import { render, staticRenderFns } from "./LgsRequirementConformityHistory.vue?vue&type=template&id=8442e9d0&scoped=true&"
import script from "./LgsRequirementConformityHistory.vue?vue&type=script&lang=js&"
export * from "./LgsRequirementConformityHistory.vue?vue&type=script&lang=js&"
import style0 from "./LgsRequirementConformityHistory.vue?vue&type=style&index=0&id=8442e9d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8442e9d0",
  null
  
)

export default component.exports